import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function PercentageChartNewLabel({ label, width }) {
	return <Box
		display="flex"
		justifyContent="flex-start"
		width={`${width}%`}
		height={1}
		borderRight="1px solid black"
		pl={0.4}
	>
		<Typography variant="button" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" sx={{ textTransform: 'none' }}>
			{label}
		</Typography>
	</Box>
}